import Api from './api.service';

const ENDPOINT = 'banks';

export default {
  search: (term = '') => Api.get(`${ENDPOINT}/list-banks?filter[name]=${term}`),
  getBank: (bank_number) =>
    Api.get(`${ENDPOINT}/get-bank`, { params: { bank_number } }),
};
